<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12" ref="notificationssetting">
            <v-card class="flex background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Impostazioni Email</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-subheader class="pl-6">Campagne</v-subheader>
                <v-container fluid class="pa-0">
                    <v-row class="pb-2 mx-0">
                        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 px-6">
                            <v-text-field 
                                label="Da"
                                v-model="settings['compaign_email_from']"
                                outlined
                                dense
                                :error-messages="errors.collect('Da')"
                                v-validate="'required|email'"
							    data-vv-name="Da"
                            ></v-text-field>                           
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 px-6">
                            <v-text-field 
                                label="Nome Mittente"
                                v-model="settings['compaign_email_from_name']"
                                outlined
                                dense
                                :error-messages="errors.collect('Nome Mittente')"
                                v-validate="'required'"
							    data-vv-name="Nome Mittente"
                            ></v-text-field>                           
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 px-6">
                            <v-switch
                                class="text-center mt-0"
                                inset
                                label="Invia a contatti"
                                v-model="settings['contacts_campaign']"
                                color="primary"
                            ></v-switch>
                            <small>Se non specificano nella campagna avvia la campagna sui contatti</small>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 px-6" v-if="settings['contacts_campaign']">
                            <v-autocomplete 
                                label="Tipo Contatto*"
                                v-model="settings['campaign_contact_type']"
                                :items="contactTypes"
                                multiple
                                small-chips
                                outlined
                                dense
                                :error-messages="errors.collect('Tipo Contatto')"
                                v-validate="'required'"
							    data-vv-name="Tipo Contatto"                                
                            ></v-autocomplete>
                            <small>Se non specificano nella campagna invia a questa tipologia di contatto se presente</small>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-6 col-lg-6 px-6" v-if="settings['campaign_contact_type']">
                            <v-switch
                                class="text-center mt-0"
                                inset
                                label="Invia a mail anagrafica se non è presente il tipo contatto scelto"
                                v-model="settings['campaign_send_to_company_mail']"
                                color="primary"
                            ></v-switch>
                            <small>Se non è presente alcun contatto con il tipo selezionato invia la mail all'indirizzo email dell'anagrafica</small>
                        </v-col>
                    </v-row>
                </v-container>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>

		<v-col class="pa-0 pt-4" cols="12">
			<crud
				title='Tipo Campagna'
				action-icon='widgets'
				model-def='generaltypes-campaign_type'
				action-position='absolute'
				:crud-dialog="true"
			></crud>
		</v-col>

    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

    export default {
        name: 'mailmarketing-options',
		mixins: [SettingsOptionsMixin],
        props: {},

        data() {
            return {
                model: 'mailmarketing',
                settings: {
                    'compaign_email_from': '',
                    'compaign_email_from_name': '',
                },
                contactTypes: []
            }
        },

        watch: {
            'settings.contacts_campaign': {
                handler(newVal, oldVal) {
                    if(!newVal)
                        this.settings.campaign_contact_type = null
                }
            }
        },

        created() {
            this.axios.post('generaltype/', {key: 'contact_type'}).then(response => {
                this.contactTypes = response.data.general_type

                this.$store.commit('endProgress')

            }, response => {
            // error callback
            })
        }
    }
</script>